// extracted by mini-css-extract-plugin
export default {"search":"TableSearch_search__Ew7kb","icon":"TableSearch_icon__tawq-","input":"TableSearch_input__kyCwN","clear":"TableSearch_clear__836Xs"};